import styled from 'styled-components';

// const Wrapper = styled.div`
//   position: absolute;
//   top: 0;
//   z-index: 9;
//   width: 260px;
//   min-height: 100vh;
//   padding: 30px;
//   background-color: ${p => p.theme.colors.primary500};
//   > img {
//     margin: 0 auto;
//   }
// `;

const Wrapper = styled.div<{ isMobile: boolean }>`
  position: fixed;
  top: 0;
  z-index: 9;
  transition: width 0.3s ease-in-out;
  width: ${(p) => (p.isMobile ? '100%' : '260px')};
  height: 100vh;
  min-height: 100%;
  overflow-y: auto;
  background: linear-gradient(180deg, #0f319d 51.56%, #4ebbc6 100%);
  color: ${(p) => p.theme.colors.light};

  && .sidebar-menu-item.MuiListItem-root {
    box-sizing: border-box;
    min-height: 52px;
    padding-top: 8px !important;
    padding-right: 24px !important;
    padding-bottom: 8px !important;
    padding-left: 24px !important;
    color: inherit;
    transition: background-color 0.2s ease-in-out;
  }

  .sidebar-menu-item > .MuiListItemIcon-root {
    display: flex;
    align-items: center;
    min-width: 44px;
    color: inherit;
  }

  .sidebar-menu-item > .MuiListItemIcon-root img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  .sidebar-menu-item > .MuiListItemText-root {
    min-width: 0;
    margin: 0;
  }

  .sidebar-menu-item .MuiListItemText-primary {
    font-size: ${(p) => p.theme.fontSizes.base};
    font-weight: 500;
    line-height: 1.3;
    overflow-wrap: anywhere;
  }

  .sidebar-menu-item.MuiListItem-root:hover {
    background-color: ${(p) => p.theme.colors.primary300};
    position: relative;
  }

  .sidebar-menu-item.MuiListItem-root:hover::before {
    content: '';
    position: absolute;
    width: 8px;
    height: 100%;
    left: 0px;
    top: 0px;
    background-color: ${(p) => p.theme.colors.secondary400};
  }

  .sidebar-menu-item.MuiListItem-root:focus-visible {
    z-index: 1;
    outline: 2px solid ${(p) => p.theme.colors.secondary300};
    outline-offset: -2px;
  }

  .sidebar-disclosure-icon {
    width: 20px;
    height: 20px;
    flex: 0 0 auto;
    transition: transform 0.2s ease-in-out;
  }

  > .MuiList-root.disabled {
    color: ${(p) => p.theme.colors.primary400};
  }
`;

const CollapsWrapper = styled.div`
  && .sidebar-submenu-item.MuiListItem-root {
    box-sizing: border-box;
    min-height: 48px;
    padding-top: 6px !important;
    padding-right: 16px !important;
    padding-bottom: 6px !important;
    padding-left: 48px !important;
    color: inherit;
    transition: background-color 0.2s ease-in-out;
  }

  .sidebar-submenu-item > .MuiListItemIcon-root {
    display: flex;
    align-items: center;
    min-width: 40px;
    color: inherit;
  }

  .sidebar-submenu-item > .MuiListItemIcon-root img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  .sidebar-submenu-item > .MuiListItemText-root {
    min-width: 0;
    margin: 0;
  }

  .sidebar-submenu-item .MuiListItemText-primary {
    font-size: ${(p) => p.theme.fontSizes.sm};
    font-weight: 500;
    line-height: 1.3;
    overflow-wrap: anywhere;
  }

  .sidebar-submenu-item.MuiListItem-root:hover {
    background-color: ${(p) => p.theme.colors.primary300};
    position: relative;
  }

  .sidebar-submenu-item.MuiListItem-root:hover::before {
    content: '';
    position: absolute;
    width: 8px;
    height: 100%;
    left: 0px;
    top: 0px;
    background-color: ${(p) => p.theme.colors.secondary400};
  }

  .sidebar-submenu-item.MuiListItem-root:focus-visible {
    z-index: 1;
    outline: 2px solid ${(p) => p.theme.colors.secondary300};
    outline-offset: -2px;
  }
`;

const UnreadCounter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  line-height: 25px;
  color: ${(p) => p.theme.colors.light};
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.red};
  margin-left: 10px;
`;

export { Wrapper, CollapsWrapper, UnreadCounter };
